import VueRouter from "vue-router";

import HomePage from '../components/HomePage/HomePage'
import IndustryApplication from '../components/IndustryApplication/IndustryApplication'
import About from '../components/about'
import Platform from '../components/Platform/platform'
// import News from '../components/news'
// import Partner from '../components/partner'

export default new VueRouter({
    routes:[
        //路由重定向
        { path:'/', redirect:'/homepage', meta: { title: '首页' } },
        
        { path:'/homepage', component: HomePage, meta: { id: 0 }},
        { path:'/industryApplication', component: IndustryApplication, meta: { id: 2 }},
        { path:'/about', component: About, meta: { id: 4 }},
        { path:'/platform', component: Platform, meta: { id: 1 }},
        // { path:'/news', component: News, meta: { id: 3 }},
        // { path:'/partner', component: Partner, meta: { id: 5 }},
    ]
})